import { useEffect, useState } from "react";
import CardSeplag from "../../../components/CardSeplag";
import TableSeplag from "../../../components/TableSeplag";
import { pesquisar, pesquisarNomeCPF } from "../../../service/seguranca/usuario";
import { useHistory } from "react-router-dom";

const Usuarios = () => {
  const [ListaUsuario, setListaUsuario] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [busca, setBusca] = useState(null);
  const [numPage, setNumPage] = useState(0);
  const [size, setSize] = useState(10);

  const camposTabela = [
    { titulo: "Nome", nome: "pessoa.nomePessoa" },
    { titulo: "E-mail", nome: "pessoa.descEmail" },
    { titulo: "CPF", nome: "pessoa.cpfFormatado" },
    { titulo: "Matrícula", nome: "pessoa.servidor.numrMatricula" },
  ];

  let history = useHistory();

  useEffect(() => {
    buscarDados(null, size, numPage);
  }, []);

  const paginacao = (event) => {
    setSize(event.rows);
    setNumPage(event.page);
    buscarDados(busca, event.rows, event.page);
  };

  const onEditarDado = (data) => {
    history.push({ pathname: "/usuario", state: { data } });
  };

  function onAdicionarDado() {
    history.push({ pathname: "/usuario" });
  }

  const onBuscaPorNomeCPF = (inputValue) => {
    setBusca(inputValue);
    buscarDados(inputValue, size, numPage);
  };

  function buscarDados(campobusca, v_size, v_numPage) {
    let filtro = `size=${v_size}&page=${v_numPage}`;
    if (campobusca) {
      pesquisarNomeCPF(campobusca, v_size, v_numPage).then((res) => {
        setListaUsuario(res.content);
        setTotalRecords(res.totalElements);
      });
    } else {
      pesquisar(filtro).then((res) => {
        setListaUsuario(res.content);
        setTotalRecords(res.totalElements);
      });
    }
  }

  return (
    <>
      <CardSeplag title="SEGURANÇA: CADASTRO DE USUÁRIOS">
        <TableSeplag
          hasEventoAcao
          camposTabela={camposTabela}
          dados={ListaUsuario}
          onAdicionarDado={onAdicionarDado}
          onEditarDado={onEditarDado}
          onPage={paginacao}
          onSearch={onBuscaPorNomeCPF}
          totalRecords={totalRecords}
          rows={size}
        />
      </CardSeplag>
    </>
  );
};
//
export default Usuarios;
